// extracted by mini-css-extract-plugin
export default {"emptyContainer":"Hg","light":"Ig","wysiwyg":"Jg","action":"Kg"};